//import runtimeEnv from '@mars/heroku-js-runtime-env';
const env = process.env;
export default function(state = [], action) {
  if (env.REACT_APP_DEV || env.REACT_APP_LOCALHOST) {
  }
    // DESA-2607: las acciones de "sin venta" tienen su propio indicador de carga (Wrapper / modal),
    // no deben tocar el loading GLOBAL — si no, deshabilitan botones de toda la app (ej: cerrar el
    // modal de productos externos) mientras la grilla sin-venta carga (puede tardar hasta 7 min).
    if (action.type.indexOf('NO_SALES') !== -1)
      return state
    if (action.type.substr(action.type.length - 7) === 'PENDING')
      return {loading:true}
    else if (action.type.substr(action.type.length - 9) === 'FULFILLED')
      return {loading:false}
    else if (action.type.substr(action.type.length - 8) === 'REJECTED')
      return {loading:false}
    else
      return state
}